import { render, staticRenderFns } from "./BasePreloader.vue?vue&type=template&id=f842d6ca&scoped=true&lang=pug&"
import script from "./BasePreloader.vue?vue&type=script&lang=js&"
export * from "./BasePreloader.vue?vue&type=script&lang=js&"
import style0 from "./BasePreloader.vue?vue&type=style&index=0&id=f842d6ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f842d6ca",
  null
  
)

export default component.exports